
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-group-iv-workshop",
      function () {
        return require("private-next-pages/tnpsc-group-iv-workshop/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-group-iv-workshop"])
      });
    }
  